Vue.component('balances-import', {

    props: {
        'trans': {
            type: Object
        },
        'restaurantId': {
            type: Number
        },
        'lastActivity': {
            type: Array
        }
    },

    data() {
        return {
            form: {
                loading: false
            },
            fileDrop: {
                hover: false,
                selected: false,
                title: '',
                file: null
            },
            infopanel: {
                show: false,
                type: "success",
                errors: [],
                message: ""
            },
            errorsModal: {
                title: "",
                errors: []
            },
            mutableLastActivity: this.lastActivity
        };
    },

    methods: {
        created() {
            this.clearFile();
        },

        fileChanged(evt)
        {
            this.droppingStateOff();

            var input = evt.target;
            if (input.files && input.files[0])
            {
                const reader = new FileReader();

                reader.onload = () => {
                    this.fileDrop.selected = true;
                    this.fileDrop.title = input.files[0].name;
                };

                this.fileDrop.file = input.files[0];
                reader.readAsDataURL(input.files[0]);
            }
            else {
                this.clearFile();
            }
        },

        fileDropped(evt)
        {
            // convert draggable event into file changed event (they have different props for storing data about selected file)
            this.fileChanged({ 'target': { 'files': evt.dataTransfer.files } });
        },

        clearFile()
        {
            $(".file-upload-input")[0].value = null;
            this.fileDrop.selected = false;
            this.fileDrop.title = "";
        },

        onSubmitUploadForm()
        {
            const formData = new FormData();
            formData.append('restaurant_id', this.restaurantId);
            formData.append('file', this.fileDrop.file, this.fileDrop.file.name);

            this.form.loading = true;
            axios.post('/import/balances/store', formData, {}).then((res) => {
                this.form.loading = false;
                this.mutableLastActivity = [ res.data.import, ...this.mutableLastActivity ];

                this.fileDrop.selected = false;

                this.infopanel.show = true;
                this.infopanel.message = (res.data.status ? this.trans.messages.result_success : this.trans.messages.result_warning);
                this.infopanel.type = (res.data.status ? "success" : "warning");
                this.infopanel.errors = res.data.errors;

            }, (error) => {
                this.form.loading = false;

                this.infopanel.show = true;
                this.infopanel.type = "danger";
                this.infopanel.message = this.trans.messages.result_danger;
                this.infopanel.errors = [ {"error": error}];
            });
        },

        droppingStateOn()
        {
            this.fileDrop.hover = true;
        },

        droppingStateOff()
        {
            this.fileDrop.hover = false;
        },

        showErrorsModal(item)
        {
            this.errorsModal.title = "Import "+item.created_at;
            this.errorsModal.errors = item.errors;
        }
    }

});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/import-export/balances-import.js